import { useContext } from 'react';

import { FeatureFlagContext } from 'src/contexts/FeatureFlagProvider';
import { FeatureFlagName } from 'src/contexts/FeatureFlagProvider/utils/featureFlagHelpers';

const useFeatureFlag = (featureName: FeatureFlagName): boolean => {
    const { isFeatureEnabled } = useContext(FeatureFlagContext);
    return isFeatureEnabled(`${process.env.STAGE}_${featureName}`);
};

export default useFeatureFlag;
